module.exports = __webpack_public_path__ + "img/转发@2x.e24048dd.png";